/**
 * Energy AI Column Constants
 *
 * Sizing and copy for the Energy AI stage column rendered beside the compressor
 * sequencer table.
 */

/** Width of the Energy AI column, matched by the header, cells and loading skeleton. */
export const ENERGY_AI_COLUMN_CLASS = 'w-28 min-w-28';

/** Header tooltip while Energy AI is in control of the sequence. */
export const ENERGY_AI_HEADER_TOOLTIP_ACTIVE =
  'Energy AI is currently selecting the optimal compressor sequence.';

/** Header tooltip while Energy AI is configured but not in control. */
export const ENERGY_AI_HEADER_TOOLTIP_INACTIVE =
  'Energy AI is not currently selecting the compressor sequence.';

/** Accessible name for the header's info control; the tooltip carries the detail. */
export const ENERGY_AI_HEADER_INFO_LABEL = 'About Energy AI';

/** Cell tooltip detail, clarifying that this column is read-only. */
export const ENERGY_AI_CELL_TOOLTIP_DETAIL = 'Energy AI sequence is not configurable';

/** Footer message shown when the forecast fetch fails but the column stays up. */
export const ENERGY_AI_FORECAST_UNAVAILABLE_DETAIL =
  'Energy AI forecast is temporarily unavailable';
